import { Helmet } from "react-helmet";
import { useState, useEffect } from "react"
import { Img, Heading, Button } from "../../components";
import { ReactTable } from "../../components/ReactTable";
import Navbar from "components/Navbar";
import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { useNavigate } from "react-router-dom";
import CheckBox from "components/CheckBox";
import axios from "axios"
import { useAppContext } from "components/Context/AppContext";

function createColumn(accessor, label) {
  const tableColumnHelper = createColumnHelper()
  return tableColumnHelper.accessor(accessor, {
    cell: (info) => (
      <Heading as="p" size="textxs" className="text-white-a700">
        {info.getValue()}
      </Heading>
    ),
    header: () => (
      <Heading
        size="headingxs"
        as="h6"
        className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
      >
        {label}
      </Heading>
    ),
    meta: { width: "104px" },
  });
}

const apiUrl = process.env.REACT_APP_API_URL;

export default function Pagedashboardedit() {

  // table data
  const [data, setData] = useState([]);
  const [token, setToken] = useState(null);
  const [refreshDB, setRefreshDB] = useState(false);
  const { isProcessRunning } = useAppContext();
  
  const navigate = useNavigate();

  //const token = sessionStorage.getItem('token');
  //setToken(token)
  const handleClickNew = () => {
    navigate('/portfolioUpload');
  }

  const handleDelete = async () => {
    const PORT_ID_LIST = data? data.filter(row => row.isChecked).map(row => row.port_id) : [];
    try {
      const response = await axios.post(`${apiUrl}/delete_portfolios`, {PORT_ID_LIST},
        {
          params: {
            token
          },
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response.data.message);
      setRefreshDB(!refreshDB)
    } catch (error) {
      console.error('Error handleDelete portfolio data:', error);
    }
  }
  

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    setToken(token)
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}/get_dashboard`, {},
          {
            params: {
              token
            },
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );
        console.log('API Response:', response.data.TableData);
        const isChecked = false
        const fetchedData = response.data.TableData.map((row, index) =>
          ({ ...row, isChecked })
        );
        
        setData(fetchedData);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };
    fetchData();

    let intervalId;
    if (isProcessRunning) {
      intervalId = setInterval(fetchData, 3000);  // Poll every 2 seconds
    }

    return () => clearInterval(intervalId);  // Clean up interval on component unmount

  }, [refreshDB, isProcessRunning]);

  

  // Update the checked state of a row
  const handleCheckboxChange = (rowIndex, isChecked) => {
    const updatedData = data.map((row, index) =>
      index === rowIndex ? { ...row, isChecked } : row
    );
    setData(updatedData);
    const checkedNames = updatedData.filter(row => row.isChecked).map(row => row.portfolioName);
    console.log("isChecked:"+checkedNames)
  };
  
  
  const tableColumns = React.useMemo(() => {
    const tableColumnHelper = createColumnHelper();
    return [
      tableColumnHelper.accessor("portfolio_name", {
        cell: (info) => (
          <div className="flex flex-1 items-end justify-center gap-3.5">
            <div className="mb-3 flex flex-1 items-center gap-[9px]">
              <CheckBox
              checked={info.row.original.isChecked}
              onChange={(isChecked) => handleCheckboxChange(info.row.index, isChecked)}
              name="Portfolio Name Checkbox"
              label={info.getValue()}
              id="PortfolioNameCheckbox"
              variant="secondary"
              className="gap-2 self-start text-[11px] font-medium text-white-a700"
            />
            </div>
          </div>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h2"
            className="pb-[22px] pl-[34px] text-left text-[12px] font-bold text-white-a700 sm:pb-5 sm:pl-5"
          >
            Portfolio Name
          </Heading>
        ),
        meta: { width: "168px" },
      }),
      createColumn("as_of_date", "As of Date"),
      createColumn("market_value", "Market Value"),
      createColumn("tail_measure", "Tail Measure"),
      createColumn("benchmark", "Benchmark"),
      createColumn("create_date", "Created Date"),
      createColumn("created_by", "Created By"),
      

      tableColumnHelper.accessor("status", {
        cell: (info) => {
          const status = info.getValue();
          const url = info.row.original.report_url; 
          const message = info.row.original.message;

          return status === 'success' ? (
            <a href={url} className="text-green-500 underline" target="_blank" rel="noopener noreferrer">
              Report
            </a>
          ) : (
            status === 'partial' ? (
              <a href={url} className="text-yellow-500 underline" target="_blank" rel="noopener noreferrer">
              Partial Report
              </a>
            ) : (
              status === 'error' ? (
                <a href={apiUrl + '/download/' + message + "?token=" + token} className="text-red-500 underline">
                  Error
                </a>
              ): (
                <>
                  <Heading as="p" size="textxs" className="text-white-a700">
                    {status}
                  </Heading>
              </>
              )
            )
          );
        },
        header: () => (
          <Heading
            size="headingxs"
            as="h6"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Status
          </Heading>
        ),
        meta: { width: "104px" },
      }),
      
      tableColumnHelper.accessor("filename", {
        cell: (info) => {
          const filename = info.getValue();
          const group_id = info.row.original.group_id; 
          const url = apiUrl +'/download/' + group_id + '/' + filename + "?token=" + token

          return <a href={url} className="text-white-a700 underline" >
            download
          </a>
        },
        header: () => (
          <Heading
            size="headingxs"
            as="h6"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Download
          </Heading>
        ),
        meta: { width: "104px" },
      }),
    ];
    
  });

  // checked rows
  const checkedNames = data? data.filter(row => row.isChecked).map(row => row.port_id) : [];

  return (
    <>
       
      <Helmet>
        <title>Edit Your Dashboard - Custom Analytics</title>
        <meta
          name="description"
          content="Tailor your dashboard for a custom view of your portfolios. Edit report dates, frequency, and more to suit your analytical needs."
        />
      </Helmet>

      <div className="w-full flex flex-col" >
      <div className="relative h-[2000px] bg-gray-900_01">
            {/* Navigation Bar */}
            <div className="container-xs absolute left-0 right-0 top-6 my-auto">
                <Navbar />
            </div>  
    
            <div className="container-xs absolute bottom-0 left-0 right-0 top-24 flex h-max flex-col gap-[52px] md:px-5 sm:gap-[26px]">
            
                <div className="flex flex-col items-start gap-1.5">
                <div className="flex flex-col items-center gap-[18px] self-stretch">
                
                    <Heading
                    size="text2xl"
                    as="h1"
                    className="text-[44px] font-medium text-white-a700 md:text-[40px] sm:text-[34px]"
                    >
                    Portfolio Manager
                    </Heading>
                    <div className="mb-[30px] flex flex-col gap-7 self-stretch">
                      <div className="mr-2.5 flex justify-center md:mr-0 sm:flex-col">
                          <Button onClick={handleClickNew} color="green_A700" size="xs1" shape="square" className="min-w-[90px] px-5">
                          Upload Portfolio
                          </Button>
                          <div onClick={handleDelete} className="flex flex-1 justify-end gap-[25px] sm:self-stretch">
                            <Button color="red_500" size="xs1" shape="square" className="min-w-[146px] px-3">
                                Delete Selected
                            </Button>
                          </div>
                      </div>
                      <ReactTable
                          size="xs"
                          bodyProps={{ }}
                          headerProps={{ className: "border-white-a700 border-b border-solid" }}
                          cellProps={{ style: { fontSize: "10px", color: "#ffffff" }, className: "border-white-a700 border-b border-solid text-xs" }}
                          className="md:block md:overflow-x-auto md:whitespace-nowrap"
                          columns={tableColumns}
                          data={data}
                      />
                      {/* 
                      <div className="mr-2.5 flex justify-center md:mr-0 sm:flex-col">
                          <div className="flex flex-1 justify-end gap-[25px] sm:self-stretch">
                            <Button color="red_500" size="xs1" shape="square" className="min-w-[146px] px-3">
                                Delete Selected
                            </Button>
                          </div>
                      </div>
                      */}
                      {/* display check rows*/}
                      {/* 
                      <div className="text-white-a700" style={{ marginTop: '20px' }}>
                        <h3>Checked Portfolios:</h3>
                          {checkedNames.length > 0 ? (
                            <>
                            <p> selected items:</p>
                            <ul>
                            {checkedNames.map((name, index) => (
                              <li key={index} className="text-red">id: {name} </li>
                            ))}
                          </ul>
                          </>
                          ) : (
                          <p>No names are checked.</p>
                        )}
                      </div>
                      */}

                  </div>
                </div>
                <div className="fixed bottom-0 left-0 flex items-center gap-[22px] bg-gray-900_02 p-1">
                    <Heading
                    size="texts"
                    as="p"
                    className="self-end text-[14px] font-medium tracking-[-0.28px] text-gray-400"
                    >
                    Powered by
                    </Heading>
                    <Img src="images/img_settings.svg" alt="Settings Image" className="h-[16px] object-contain" />
                </div>
                </div>
            </div>
            </div>
        </div>
    </>
  );
}
